import { render, staticRenderFns } from "./cancelPlatformOrderModal.vue?vue&type=template&id=f533f65e&scoped=true"
import script from "./cancelPlatformOrderModal.vue?vue&type=script&lang=js"
export * from "./cancelPlatformOrderModal.vue?vue&type=script&lang=js"
import style0 from "./cancelPlatformOrderModal.vue?vue&type=style&index=0&id=f533f65e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f533f65e",
  null
  
)

export default component.exports